import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DEVICE, STAGE_THEME } from '../../../../constants';
import S4 from './component/s4';
import K from './component/k';
import S1 from './component/s1';
import S2 from './component/s2';
import S3 from './component/s3';
import S5 from './component/s5';
import Prerise from './component/prerise';
import Trial from './component/trial';
import DeviceContext from '../device-context';
import './style.less';

const themeComponents = {
  [STAGE_THEME.K]: K,
  [STAGE_THEME.PRERISE]: Prerise,
  [STAGE_THEME.TRIAL]: Trial,
  [STAGE_THEME.S1]: S1,
  [STAGE_THEME.S2]: S2,
  [STAGE_THEME.S3]: S3,
  [STAGE_THEME.S4]: S4,
  [STAGE_THEME.S5]: S5,
};
class Background extends Component {
  static propTypes = {
    size: PropTypes.object,
    theme: PropTypes.string,
  };

  state = {
    bgNum: [1],
  };

  componentDidMount() {
    this.setBg();
  }

  setBg = () => {
    const { size } = this.props;
    if (this.context === DEVICE.PC) return;
    let num = 0;
    if (size.height) {
      const height = document.documentElement.clientHeight * 1548 / 667;
      num = Math.ceil(size.height / height);
    } else if (size.width) {
      const width = document.documentElement.clientHeight * 2057 / 768;
      num = Math.ceil(size.width / width);
    }
    const bgNum = [];
    for (let i = 0; i < num; i += 1) {
      bgNum.push(i);
    }
    this.setState({ bgNum });
  }

  themeComponent = () => {
    const ThemeComponent = themeComponents[this.props.theme];
    return ThemeComponent ? <ThemeComponent os={this.context} /> : '';
  }

  render = () => (
    <div className="background" style={{ ...this.props.size }}>
      {
        this.state.bgNum.map(item => (
          <div className="stage-bg" key={item}>
            {this.themeComponent()}
          </div>
        ))
      }
    </div>
  );
}

Background.contextType = DeviceContext;

export default Background;
